import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default{
    methods:{ 
        nextClick(iccid,userPhone,code,noCode,isBackBindCard) { // noCode 0需要授权， 1不需要授权。  // isBackBindCard 1 回到输入卡号页面
            if (!iccid) {
                Toast('请输入设备卡号！')
                return
            }
            if (!code) {
                Toast('授权失败，请重新登录！')
                return
            }
            if (!userPhone) {
                Toast('手机号缺失，请重新登录！')
                return
            }
            var recordLoginText = iccid;
            const data = {
                requestId: iccid,
                code: code,
                userPhone:userPhone,
                noCode:noCode
            }; 
            localStorage.setItem("recordLoginText", recordLoginText);
            wxRequest("sim/bind", data, "get").then((res) => {
                if (res.data.code === "200") {
                    const record = res.data.data;
                    const iccid = record.iccid;
                    recordLoginText = record.phoneNo?record.phoneNo:record.virtualNo;
                    localStorage.setItem("newUserPhone",userPhone);
                    localStorage.setItem("newLoginText",recordLoginText);
                    localStorage.setItem("isShieldAgent", record.isShieldAgent);
                    localStorage.setItem("firstVipLogin", 0);
                    localStorage.setItem("salePrice", record.salePrice);
                    localStorage.setItem("isShowApp", record.isShowApp);
                    localStorage.setItem("isShowAppMenu", record.isShowApp);
                    localStorage.setItem("PayImgUrl", record.imgUrl);
                    localStorage.setItem("payPrice", record.payPrice);
                    localStorage.setItem("isAutoHome", 1); // 1表示自动跳转到 firstHome
                    localStorage.setItem("isCode", true);
                    localStorage.setItem("mobile", record.mobile);
                    localStorage.setItem("userPhone", record.userPhone); // 用户绑定得手机号
                    localStorage.setItem("supplierTypeName", record.supplierTypeName);
                    localStorage.setItem("wxHeadImg", record.wxHeadImg);
                    localStorage.setItem("wxNickName", record.wxNickName);
                    localStorage.setItem("recordLoginText", recordLoginText);
                    localStorage.setItem("supplierName", record.supplierName);
                    localStorage.setItem("intoNo", record.intoNo);
                    localStorage.setItem("iccid", record.iccid);
                    localStorage.setItem("openId", record.openId);
                    localStorage.setItem("virtualNo", record.virtualNo);
                    localStorage.setItem("isBindPhone", record.isBindPhone);
                    localStorage.setItem("tuiPrice", record.tuiPrice); // 赠送金余额
                    localStorage.setItem("firstLogin", 1);
                    localStorage.setItem("basePkgGroup", record.basePkgGroup);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;
                    this.$store.state.iccid = iccid;
                    this.$store.commit("setIccid", iccid);
                    localStorage.setItem("newHome", 1);
                    this.$store.state.newHome = 1;
                    this.$store.state.isBindPhone = record.isBindPhone;
                    this.$store.state.intoNo = record.intoNo;
                    sessionStorage.setItem("intoNo", record.intoNo);
                    // 未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    if(record.saleType==0){
                        this.$router.replace("/newUser/home");
                    }
                    if(record.saleType==17 && record.havePkg>0){
                        this.$router.replace("/newUser/home");
                    }
                    wxRequest("sim/is/have/price", { iccid: iccid }, "get").then((res) => {
                        if (res.data.code === "200") {
                            this.$router.replace("/newUser/home"); // 其它卡
                        } else {
                            if(isBackBindCard==1){
                                this.$router.replace("/newUser/bindNew/bindingCard"); // 其它卡
                                return;
                            }
                            if (record.basePkgGroup === "1549295580465852416" ||record.basePkgGroup === "1568163178611732480" ) {
                                // 悟空卡
                                this.$router.replace("/newUser/simOpenWu");
                            }else if( record.saleType == 20){
                                this.$router.replace("/newUser/simAllOpenThree");
                            } else if (record.basePkgGroup === "1710104773937590272") {
                                //楷然直播
                                this.$router.replace("/newUser/simOpen999");
                            } else if (record.basePkgGroup === "1712013754339684352" || record.basePkgGroup === "1714210288590385152" 
                             || record.basePkgGroup === "1807621869617016833" || record.basePkgGroup === "1715188857181302784"
                             || record.basePkgGroup === "1854435462677000192" || record.saleType >= 12) {
                                //统一页面
                                this.$router.replace("/newUser/simAllOpen");
                            } else if (record.saleType >= 10) {
                                this.$router.replace("/new/serviceCenter");
                            }else if (record.basePkgGroup === "1587749406130565120" ) {
                                // 悟空卡Puls  105G
                                this.$router.replace("/newUser/simOpenWup");
                            } else if (record.basePkgGroup === "1549295498467209216") {
                                // 乐享卡
                                this.$router.replace("/newUser/simOpenLe");
                            } else if (record.basePkgGroup === "1562613197939142656" ||record.basePkgGroup === "1565598068475162624" ) {
                                // 乐信卡 80元得240
                                this.$router.replace("/user/simOpenLex");
                            } else if (
                                record.basePkgGroup === "1574325852529750016" ||
                                record.basePkgGroup === "1574325802546229248"
                            ) {
                                // 悟净卡 开户预存 送赠送金
                                this.$router.replace("/user/cardOpens");
                            } else if (
                                record.basePkgGroup === "1579392078893281280" ||
                                record.basePkgGroup === "1579369236420096000" ||
                                record.basePkgGroup === "1579369201724813312"
                            ) {
                                // 冰星系列 开户预存+赠送金
                                this.$router.replace("/user/rechargePrice");
                                // 畅享卡系列 30*3+20*9优惠券  9.9元套餐
                            } else if (
                                record.basePkgGroup === "1588080292403343360"
                            ) {
                                this.$router.replace("/newUser/simOpenCxk");
                            }
                            // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                            else if (record.basePkgGroup === "1595609837910093824") {
                                this.$router.replace("/user/simOpenXy");
                            }
                            // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
                            else if (record.basePkgGroup === "1595609014362697728") {
                                this.$router.replace("/newUser/simOpenYx");
                            } else if (
                                record.basePkgGroup === "1597081108845948928"
                            ) {
                                this.$router.replace("/newUser/simOpenXy8");
                            } else if (
                                record.basePkgGroup === "1620242289261539328"
                            ) {
                                this.$router.replace("/newUser/simOpenTn");
                            }
                            else if (
                                record.basePkgGroup === "1639175906637377536"
                            ) {
                                this.$router.replace("/newUser/simOpenXc");
                            } else if (
                                record.basePkgGroup === "1643557236171075584"
                            ) {
                                this.$router.replace("/newUser/simOpenXcp");
                            } else if (
                                record.basePkgGroup === "1647873729625059328"
                            ) {
                                this.$router.replace("/newUser/simOpenTnVip");
                            } else if (
                                record.basePkgGroup === "1643829249842343936"
                            ) {
                                this.$router.replace("/newUser/simOpenTnBz");
                            } else if (
                                record.basePkgGroup === "1656908136637788160"
                            ) {
                                this.$router.replace("/newUser/simOpenTnPUp");
                            } else if (
                                record.basePkgGroup === "1671694964578316288"
                            ) {
                                this.$router.replace("/newUser/simOpenZb");
                            }
                            else if (
                                record.basePkgGroup === "1695020545449390080"
                            ) {
                                this.$router.replace("/newUser/simOpen100");
                            } else if (
                                record.basePkgGroup === "1695000953494695936"
                            ) {
                                this.$router.replace("/newUser/simOpen105");
                            } else if (
                                record.basePkgGroup === "1695000884909436928"
                            ) {
                                this.$router.replace("/newUser/simOpen108");
                            } else if (record.isBindPhone !== 1 && record.havePkg > 0) {
                                this.$router.replace("/newUser/bindPhone");
                            } else {
                                this.$router.replace("/newUser/home"); // 其它卡
                            }
                        }
                    });

                }else if(res.data.code === "404" ||res.data.code ==404){
                    Dialog.alert({ title: "提示", message: res.data.message });
                    this.$router.replace("/newUser/bindNew/bindingCard");
                }
                 else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            });

        },
    }
}